export default async function getCurrentWorkflowActions(fetchWorkflowActions, group) {
  // NOTE: if this group is split, the currentWorkflowActions probably aren't in the state,
  // so we need to explicitly request them
  if (!group?.id) return []
  const currentWorkflowActions = Array.isArray(group?.currentWorkflowActions)
    ? group.currentWorkflowActions
    : (await fetchWorkflowActions({ variables: { groupIdOrArkId: group?.id } }))?.data?.group?.currentWorkflowActions

  return currentWorkflowActions
}
